import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { jsx as ___EmotionJSX } from "@emotion/react";
const noProviderErrorFunction = () => {
  throw new Error('EntityContext cannot be used without being contained within an EntityProvider');
};

// eslint-disable-next-line @typescript-eslint/no-empty-interface

export const createEntityProvider = _ref => {
  let {
    setExerciseEntity
  } = _ref;
  const EntityContext = React.createContext({
    getExercise: noProviderErrorFunction,
    setExercise: noProviderErrorFunction
  });
  const EntityProvider = _ref2 => {
    let {
      children
    } = _ref2;
    const dispatch = useDispatch();
    const exerciseEntities = useSelector(state => state.exerciseEntities);
    const getExercise = React.useCallback(exerciseId => exerciseEntities[exerciseId], [exerciseEntities]);
    const setExercise = React.useCallback((exerciseId, exerciseEntity) => {
      dispatch(setExerciseEntity(exerciseId, exerciseEntity));
    }, [dispatch]);
    return ___EmotionJSX(EntityContext.Provider, {
      value: {
        getExercise,
        setExercise
      }
    }, children);
  };
  return {
    EntityContext,
    EntityProvider
  };
};